"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const card_1 = require("./card");
const errors_1 = require("./errors");
class Hand {
    constructor(cards) {
        this.cards = cards.map(c => new card_1.Card(c));
    }
    toJSON() {
        return this.cards.map(c => c.serializeWithHints());
    }
    dealOne(card) {
        this.cards.push(card);
    }
    take(idx, stock) {
        if (!this.cards[idx]) {
            console.warn({ idx }, this.cards);
            throw new errors_1.GameError('NO_SUCH_CARD', { idx });
        }
        const drawnCard = this.cards.splice(idx, 1)[0];
        if (stock.size) {
            const newCard = stock.drawOne();
            this.cards.push(new card_1.Card({ color: newCard.color, num: newCard.num, hints: [] }));
        }
        return drawnCard;
    }
    get size() {
        return this.cards.length;
    }
    addHint(hint) {
        for (const c of this.cards) {
            c.addHint(hint);
        }
    }
}
exports.Hand = Hand;
// readonly class
class MaskedPlayerView {
    constructor(s) {
        this.hand = s.hand.map(c => new card_1.MaskedCard(c));
        this.isMe = s.isMe;
    }
    toJSON() {
        return { hand: this.hand.map(c => c.toJSON()), isMe: this.isMe, extraMysticalHand: this.extraMysticalHand };
    }
}
exports.MaskedPlayerView = MaskedPlayerView;
//# sourceMappingURL=hand.js.map